export enum Pages {
  HOME = '/',
  PROGRESS = 'progress/profile.html',
  PRIVATE_CLASSES = '/private-classes.html',
  REFERRAL_PROGRAM = '/referrals.html',
  NOTIFICATIONS = '/account/notifications.html',
}

export enum Sections {
  LIVE_CLASSES = 'live-classes',
  LESSONS = 'lessons',
  PRACTICE = 'practice',
  YEAR_IN_REVIEW = 'year-in-review',
  PRIVATE_CLASSES = 'private-classes',
  CERTIFICATES = 'certificates',
  GAME = 'game',
  CHAT_BOT = 'chat-bot',
}

export const PagesSectionsMap = {
  [Pages.HOME]: [
    Sections.LIVE_CLASSES,
    Sections.LESSONS,
    Sections.PRACTICE,
    Sections.YEAR_IN_REVIEW,
    Sections.CHAT_BOT,
  ],
  [Pages.PROGRESS]: [Sections.CERTIFICATES, Sections.GAME],
};



// WEBPACK FOOTER //
// ./ts/app/shared/types/deep-linking.ts